module.exports = __webpack_public_path__ + "img/move-hero-medium.cea9c95f.png";